import { DartAiIcon } from "~/icons";
import { AgentCategory } from "~/shared/enums";
import type { AgentConfig } from "~/shared/types";

import Icon from "./Icon.vue";

const config: AgentConfig = {
  name: "Dart AI",
  category: AgentCategory.ASSISTANT,
  icon: Icon,
  agentIcon: DartAiIcon,
  color: "#a855f7",
  helpUrl: "https://help.dartai.com/en/articles/12037165-dart-ai",
  description: "Plan, manage, and build any tasks or projects you can imagine",
  configFields: [],
};

export default config;
